<template>
<transition name="modal-fade">
    <div class="modal-backdrop">
        <div class="modal">
            <div class="modal-body">
                <slot name="body">
                    <p class="title">{{title}}</p>
                    <template v-if="type == 1">
                        <div class="info" >
                            <p><span>1.</span><span>选中心意商品，点击“加入购物车”或者“立即兑换”按钮</span></p>
                            <p><span>2.</span><span>按提示填写您的收货地址及相关信息</span></p>
                            <p><span>3.</span><span>确认信息无误，点击“确认兑换”按钮，扣除相应的余额</span></p>
                            <p><span>4.</span><span>可在兑换页面按订单信息查看</span></p>
                        </div>
                    </template>
                    <template v-else>
                        <div class="info">
                            <p><span>1.</span><span>所有实物商品均由京东发货，配送时间、区域以系统提示为准</span></p>
                            <p><span>2.</span><span>所有商品已经兑换不可退换货，请用户兑换前仔细阅读兑换规则</span></p>
                            <p><span>3.</span><span>请用户提供正确收货地址及相关信息，保持手机畅通，如因错误信息导致损失将由用户承担</span></p>
                            <p><span>4.</span><span>实物商品物流信息可在我的订单中查看</span></p>
                            <p><span>5.</span><span>超500元商品使用权为3年</span></p>
                        </div>
                    </template>
                </slot>
            </div>
            <div class="modal-footer">
                <slot name="footer">
                    <p @click="close">知道了</p>
                </slot>
            </div>
        </div>
    </div>
</transition>
</template>
<script>
export default {
    props:["type"],
    data() {
        return {
        }
    },
    methods: {
        close() {
            this.$emit('close')
        }
    },
    computed: {
        title () {
            if (this.type == 1) {
                return '兑换流程'
            }else {
                return '兑换规则'
            }
        }
    },
}
</script>
<style scoped lang="less">
.modal-backdrop {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, .3);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;
}

.modal {
    background-color: #fff;
    box-shadow: 2px 2px 20px 1px;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
    width: 78.2666vw;
    border-radius: 1vw;
}

.modal-body {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    color: #000;

    .title {
        padding: 6vw 0;
        font-size: 4.8vw;
        text-align: center;
    }
    .info {
        padding: 0 8vw;
        line-height: 1.5;
        margin-bottom: 3vw;
        font-size: 4vw;
        p {
            display: flex;
            margin-bottom: 3vw
        }
    }
    img {
        width: 16.2666vw;
        height: 16.2666vw;
        margin-bottom: 2.66666vw;
    }
    p {
        width: 100%;
        margin: 0;
    }
    
}

.modal-footer {
    display: flex;
    flex: 2;
    p {
        flex: 1;
        margin: 0;
        text-align: center;
        font-size: 4vw;
        padding: 3.0666vw;
    }
    p:last-child {
        background-image: linear-gradient(to right, #ff0d33, #ff7f5f);
        color: #fff;
    }
    border-top: 1px solid #eee;
    justify-content: flex-end;
}

.btn-close {
    border: none 0;
    font-size: 20px;
    padding: 20px;
    cursor: pointer;
    font-weight: bold;
    color: #4aae9b;
    background-color: transparent;
}

.btn-green {
    color: #fff;
    background-color: #4aae9b;
    border: 1px solid #4aae9b;
    border-radius: 2px;
}

.modal-fade-enter,
.modal-fade-leave-active {
    opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
    transition: opacity .5s ease
}
</style>




// WEBPACK FOOTER //
// src/components/common/Modal/tips.vue